import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionStorageService } from '../web-storage/session-storage/session-storage.service';

@Injectable()
export class EntityIdInterceptor implements HttpInterceptor {
  constructor (
    private sessionStorageService: SessionStorageService,
  ) { }

  intercept (request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const entityId = this.getEntityId();
    request = this.isNonEntityEndpoint(request.url) || !entityId
      ? request
      : request.clone({
        setHeaders: {
          'nv-entity-id': entityId,
        },
      });
    return next.handle(request);
  }

  getEntityId () {
    return this.sessionStorageService.getItem('entityId');
  }

  isNonEntityEndpoint (requestUrl: string) {
    const endpoints = ['/v1/status', '/v1/districtUsers'];
    return endpoints.some((endpoint) => requestUrl.includes(endpoint));
  }
}
